import type { SortType } from "@apptus/esales-api";
import type { Sort } from "types";

const table = {
  favorites: undefined,
  popularity: undefined,
  relevance: "RELEVANCE",
  name_asc: "NAME",
  name_desc: undefined,
  price_asc: "PRICE_ASCENDING",
  price_desc: "PRICE_DESCENDING",
  newest: "NEWEST_FIRST",
  in_stock: undefined,
} as Record<string, SortType | undefined>;

export default function mapNgSort(sort?: Sort): SortType | undefined {
  if (!sort) return;
  return table[sort];
}
